import { SelectedDeliveryOption } from "../types";
import { CPTSlabForManualOption } from "../../../views/Orders/enums";

export interface ValidationConfig {
  directDeliveryMinimumDeliveryCost?: number;
}

export interface ValidationError {
  id: string;
  message: string;
  targetField?: "deliveryCharge" | "cpt" | "cptSlab" | "general";
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
  errorsByField: Record<string, ValidationError[]>;
}

export interface DeliverySelectionValidationRule {
  id: string;
  targetField?: "deliveryCharge" | "cpt" | "cptSlab" | "general";

  shouldApply: (
    selection: SelectedDeliveryOption,
    config: ValidationConfig,
  ) => boolean;

  validate: (
    selection: SelectedDeliveryOption,
    config: ValidationConfig,
  ) => boolean;

  getErrorMessage: (
    selection: SelectedDeliveryOption,
    config: ValidationConfig,
  ) => string;
}

export const DELIVERY_SELECTION_VALIDATION_RULES: DeliverySelectionValidationRule[] =
  [
    {
      id: "manual-direct-delivery-min-delivery-charge",
      targetField: "deliveryCharge",
      shouldApply: (selection) =>
        selection.deliveryDetails?.selectionType === "manual" &&
        selection.deliveryDetails?.manualEntry?.cptSlab ===
          CPTSlabForManualOption.DIRECT_DELIVERY,
      validate: (selection, config) => {
        const charge = selection.deliveryDetails?.manualEntry?.deliveryCharge;
        const minCharge = config.directDeliveryMinimumDeliveryCost ?? 50;
        return charge !== undefined && charge !== null && charge >= minCharge;
      },
      getErrorMessage: (selection, config) => {
        const minCharge = config.directDeliveryMinimumDeliveryCost ?? 50;
        return `Delivery charge must be at least ₹${minCharge} for Direct Delivery`;
      },
    },
    {
      id: "manual-self-pickup-zero-delivery-charge",
      targetField: "deliveryCharge",
      shouldApply: (selection) =>
        selection.deliveryDetails?.selectionType === "manual" &&
        selection.deliveryDetails?.manualEntry?.cptSlab ===
          CPTSlabForManualOption.SELF_PICKUP,
      validate: (selection) => {
        const charge = selection.deliveryDetails?.manualEntry?.deliveryCharge;
        return charge !== undefined && charge !== null && Number(charge) === 0;
      },
      getErrorMessage: () => "Delivery charge must be ₹0 for Self Pickup",
    },
  ];
